module.exports = __webpack_public_path__ + "7466d6ee5844489735964e7e65cea76d.svg";